(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if(!customElements.get('vls-flavor-order'))customElements.define('vls-flavor-order',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.form=this.querySelector('form');
    this.rows=Array.from(this.querySelectorAll('[data-flavor-row]'));
    this.all=this.querySelector('[data-flavor-select-all]');
    this.status=this.querySelector('[data-flavor-status]');
    this.button=this.querySelector('[data-flavor-submit]');
    this.querySelector('.vls-flavor-tools').hidden=false;
    this.querySelector('.vls-flavor-summary').hidden=false;
    this.querySelector('[data-flavor-search]').addEventListener('input',event=>{
      const query=event.target.value.trim().toLocaleLowerCase();
      this.rows.forEach(row=>row.hidden=!row.dataset.search.includes(query));
      this.querySelector('[data-flavor-empty]').hidden=this.rows.some(row=>!row.hidden);
      this.update();
    });
    this.all.addEventListener('change',()=>{
      this.rows.filter(row=>!row.hidden).forEach(row=>{const check=row.querySelector('[data-flavor-check]');if(!check.disabled)check.checked=this.all.checked;});
      this.update();
    });
    this.form.addEventListener('change',event=>{
      if(event.target.matches('[data-flavor-variant]')){
        const row=event.target.closest('[data-flavor-row]');
        const option=event.target.selectedOptions[0];
        const quantity=row.querySelector('[data-flavor-quantity]');
        quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';
        if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
        if(!quantity.checkValidity())quantity.value=quantity.min;
      }
      this.update();
    });
    this.form.addEventListener('input',()=>this.update());
    this.form.addEventListener('submit',event=>this.submit(event));
    this.dialog=this.querySelector('.vls-flavor-product-window');
    this.detailSelect=this.querySelector('[data-flavor-detail-variant]');
    this.detailQuantity=this.querySelector('[data-flavor-detail-quantity]');
    this.addEventListener('click',event=>{
      const link=event.target.closest('.vls-flavor-name a');
      if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      this.opener=link;
      this.querySelector('[data-flavor-window-title]').textContent=link.textContent;
      this.querySelector('[data-flavor-full-page]').href=link.href;
      this.detailRow=link.closest('[data-flavor-row]');
      this.querySelector('[data-flavor-product-content]').replaceChildren(this.detailRow.querySelector('template').content.cloneNode(true));
      const rowSelect=this.detailRow.querySelector('[data-flavor-variant]');
      this.detailSelect.replaceChildren(...Array.from(rowSelect.options,option=>option.cloneNode(true)));
      this.detailSelect.value=rowSelect.value;
      this.detailSelect.disabled=rowSelect.disabled;
      this.detailQuantity.value=this.detailRow.querySelector('[data-flavor-quantity]').value;
      this.detailQuantity.disabled=rowSelect.disabled;
      this.querySelector('[data-flavor-detail-select]').disabled=rowSelect.disabled;
      this.detailRules();
      this.dialog.showModal();
    });
    this.querySelector('[data-flavor-window-close]').addEventListener('click',()=>this.dialog.close());
    this.detailSelect.addEventListener('change',()=>this.detailRules());
    this.querySelector('[data-flavor-detail-select]').addEventListener('click',()=>{
      if(!this.detailQuantity.reportValidity())return;
      const rowSelect=this.detailRow.querySelector('[data-flavor-variant]');
      rowSelect.value=this.detailSelect.value;
      rowSelect.dispatchEvent(new Event('change',{bubbles:true}));
      this.detailRow.querySelector('[data-flavor-quantity]').value=this.detailQuantity.value;
      this.detailRow.querySelector('[data-flavor-check]').checked=true;
      this.update();this.dialog.close();
    });
    this.dialog.addEventListener('close',()=>{if(this.opener)this.opener.focus();});
    this.update();
  }
  detailRules(){
    const option=this.detailSelect.selectedOptions[0];
    this.detailQuantity.min=option.dataset.min||'1';this.detailQuantity.step=option.dataset.step||'1';
    if(option.dataset.max)this.detailQuantity.max=option.dataset.max;else this.detailQuantity.removeAttribute('max');
    if(!this.detailQuantity.checkValidity())this.detailQuantity.value=this.detailQuantity.min;
  }
  selected(){return this.rows.filter(row=>{const check=row.querySelector('[data-flavor-check]');return check.checked&&!check.disabled;});}
  update(){
    const selected=this.selected();
    let subtotal=0;
    selected.forEach(row=>{const option=row.querySelector('[data-flavor-variant]').selectedOptions[0];subtotal+=Number(option.dataset.price)*Math.max(0,Number(row.querySelector('[data-flavor-quantity]').value)||0);});
    this.querySelector('[data-flavor-count]').textContent=this.dataset.count.replace('__COUNT__',String(selected.length));
    this.querySelector('[data-flavor-subtotal]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format(subtotal/100);
    const eligible=this.rows.filter(row=>!row.hidden&&!row.querySelector('[data-flavor-check]').disabled);
    const checked=eligible.filter(row=>row.querySelector('[data-flavor-check]').checked).length;
    this.all.checked=eligible.length>0&&checked===eligible.length;
    this.all.indeterminate=checked>0&&checked<eligible.length;
  }
  async submit(event){
    event.preventDefault();
    if(this.busy)return;
    const selected=this.selected();
    if(!selected.length){this.status.textContent=this.dataset.none;return;}
    for(const row of selected){if(!row.querySelector('[data-flavor-quantity]').reportValidity())return;}
    const items=selected.map(row=>({id:row.querySelector('[data-flavor-variant]').value,quantity:Number(row.querySelector('[data-flavor-quantity]').value)}));
    this.busy=true;this.button.disabled=true;this.button.textContent=this.dataset.adding;this.status.textContent='';
    try{
      const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const data=await response.json();
      if(!response.ok){this.status.textContent=data.description||data.message||this.dataset.error;return;}
      window.location.assign(this.dataset.cartUrl);
    }catch(error){this.status.textContent=this.dataset.network;}
    finally{this.busy=false;this.button.disabled=false;this.button.textContent=this.dataset.add;}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vls-deals-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const opener=event.target.closest('[data-vls-deals-open]');
  const dialog=document.getElementById('VlsDealsDialog');
  if(!dialog)return;
  const cards=Array.from(dialog.querySelectorAll('.vls-deals-card'));
  const navigation=dialog.querySelector('.vls-deals-navigation');
  function showCard(index){
    if(!cards.length)return;
    cards.forEach(function(card,i){card.hidden=i!==index;card.classList.toggle('vls-deals-current',i===index);});
    dialog.dataset.dealIndex=String(index);
    dialog.querySelector('[data-vls-deals-position]').textContent=String(index+1);
    dialog.querySelector('[data-vls-deals-total]').textContent=String(cards.length);
    dialog.querySelector('[data-vls-deals-previous]').disabled=index===0;
    navigation.hidden=cards.length<2;
    dialog.scrollTop=0;
  }
  if(opener){showCard(0);if(!dialog.open)dialog.showModal();return;}
  if(event.target.closest('[data-vls-deals-next]')){showCard((Number(dialog.dataset.dealIndex||0)+1)%cards.length);return;}
  if(event.target.closest('[data-vls-deals-previous]')){showCard(Math.max(0,Number(dialog.dataset.dealIndex||0)-1));return;}
  if(event.target.closest('[data-vls-deals-close]'))dialog.close();
  if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}
});

  } catch(e) { console.error(e); }
})();
})();
